@if (isExpanded$ | async) {
  <button mat-icon-button (click)="toggle()" matTooltip="Collapse edit panel">
    <mat-icon class="material-symbols-outlined"> bottom_panel_close </mat-icon>
  </button>
} @else {
  <button mat-icon-button (click)="toggle()" matTooltip="Expand edit panel">
    <mat-icon class="material-symbols-outlined"> top_panel_close </mat-icon>
  </button>
}
